import React from 'react'

import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'

import Grid from '@material-ui/core/Grid'

export default class SaisieLibre extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0 }} justify={'center'} alignContent={'center'} alignItems={'center'} wrap={'nowrap'}>
          <Grid item xs>
            <Traduction style={this.props.style}
                        inlineWidth={this.props.inlineWidth}
                        title={this.props.title} inline={this.props.inline}
                        onChange={this.props.onChangeSaisieLibre}
                        name={'text'}
                        disabled={this.props.disabled || false}
                        data={this.props.data !== undefined ? (this.props.infoTiers === true ? this.props.data.text : this.props.data) : []}
                        type={Constants.typeSaisie.SaisieLibre}
            />
          </Grid>
          <Grid item style={{ margin: 0, padding: 10, paddingTop: 15, display: (!this.props.data || !this.props.data.media_lien) && 'none' }}>
            <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '90%', width: '100%' }} justify={'center'} alignItems={'center'} alignContent={'center'}>
              <a className={'ei-crm_public'} target="_blank" rel="noopener noreferrer"
                 href={this.props.data !== undefined ? (this.props.infoTiers === true ? this.props.data.text[0] && this.props.data.text[0].text : this.props.data[0].text) : ''}/>
            </Grid>
          </Grid>
        </Grid>
    )
  }
}




// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/SaisieLibre/SaisieLibre.js